export default __webpack_public_path__ + "static/media/AmericanExpress.a8b20596.svg";